import { render } from "./ProgressReportWo.vue?vue&type=template&id=0ba2dda4"
import script from "./ProgressReportWo.vue?vue&type=script&lang=js"
export * from "./ProgressReportWo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\40\\s\\PASVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__